// extracted by mini-css-extract-plugin
export default {"announcements":"T_fS p-2","announcement":"T_fT card my-2","announcement--highlighted":"T_fV","announcement__list-item":"T_fW py-1","announcement__flag":"T_fX"};